Vue.component('page-psf-receipt', {
    mounted() {
        if (this.$ldClient && this.$ldClient.client) {
            this.$ldClient.client.waitUntilReady().then(() => {
                this.$ldClient.client.track('psf_purchase')
            })
        }

        try {
            localStorage.removeItem('webCouponCode');
        } catch {
            // no-op
        }
    },
})
